import { Link } from '@dreryk/react-components';

import { prescriptionsHistoryDownloadTranslationKeys } from '../translations';

type GoBackToAuthorizerLinkProps = {
   readonly onClick: VoidFunction;
   readonly className?: string;
};

export const GoBackToAuthorizerChoiceLink = (props: GoBackToAuthorizerLinkProps): JSX.Element => {
   return (
      <Link
         className={props.className}
         testId={'goBackToAuthorizer'}
         onClick={props.onClick}
         label={prescriptionsHistoryDownloadTranslationKeys.goBackToAuthorizerChoice}
      />
   );
};
